import { defineComponent as p, openBlock as o, createElementBlock as e, mergeProps as i, unref as l, renderSlot as u, createElementVNode as n, createCommentVNode as Z } from "vue";
import { useScalarIcon as A } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, h = { key: 1 }, f = { key: 2 }, k = { key: 3 }, v = { key: 4 }, V = { key: 5 }, w = {
  name: "ScalarIconClock"
}, _ = /* @__PURE__ */ p({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: m, weight: a } = A(s);
    return (d, t) => (o(), e("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(m)), [
      u(d.$slots, "default"),
      l(a) === "bold" ? (o(), e("g", g, t[0] || (t[0] = [
        n("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm68-84a12,12,0,0,1-12,12H128a12,12,0,0,1-12-12V72a12,12,0,0,1,24,0v44h44A12,12,0,0,1,196,128Z" }, null, -1)
      ]))) : l(a) === "duotone" ? (o(), e("g", h, t[1] || (t[1] = [
        n("path", {
          d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm64-88a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48A8,8,0,0,1,192,128Z" }, null, -1)
      ]))) : l(a) === "fill" ? (o(), e("g", f, t[2] || (t[2] = [
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm56,112H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : l(a) === "light" ? (o(), e("g", k, t[3] || (t[3] = [
        n("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm62-90a6,6,0,0,1-6,6H128a6,6,0,0,1-6-6V72a6,6,0,0,1,12,0v50h50A6,6,0,0,1,190,128Z" }, null, -1)
      ]))) : l(a) === "regular" ? (o(), e("g", v, t[4] || (t[4] = [
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm64-88a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48A8,8,0,0,1,192,128Z" }, null, -1)
      ]))) : l(a) === "thin" ? (o(), e("g", V, t[5] || (t[5] = [
        n("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm60-92a4,4,0,0,1-4,4H128a4,4,0,0,1-4-4V72a4,4,0,0,1,8,0v52h52A4,4,0,0,1,188,128Z" }, null, -1)
      ]))) : Z("", !0)
    ], 16));
  }
});
export {
  _ as default
};
